import React, { useState } from 'react';
import DropdownSelect from '../../../components/FormElement/DropdownSelect';
import './styles.scss';
import { useSelector } from "react-redux";
import { IAppState } from "../../../store/reducers";
import { AuthState } from "../../../store/reducers/auth";
import { CreditCard } from "../../../services/dto/Security";
import { Typography, Button, Box } from '@mui/material';

export interface IModalUseCreditCardOnFileProps {
  copayValue: number
  onClose: () => void
  onAddCard: () => void
  loading: boolean
  onPayNow: (card: CreditCard) => void
}

export const ModalUseCreditCardOnFile: React.FunctionComponent<IModalUseCreditCardOnFileProps> = (props) => {
  const { copayValue, onClose, onPayNow, onAddCard } = props;
  const [currCard, setCurrCard] = useState<CreditCard>();

  // enabled Form
  const enabledForm = () => !!currCard && !props.loading
  const { authUser } = useSelector<IAppState, AuthState>(s => s.auth)
  const displayCopay = typeof copayValue === "string" ? copayValue : (copayValue || 0).toFixed(2)

  if (!authUser) {
    return <></>
  }
  
  return (
    <div className="modal-default modal-use-credit-card-on-file">
      <div className="modal-mains" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Typography variant="h5" fontWeight="bold">
          Use Credit Card On File
        </Typography>
        <DropdownSelect
          label="Select Credit Card"
          value={currCard}
          items={authUser.creditCards?.map((item, index) => ({label: item.number, value: item})) || []}
          onChange={(item: any) => setCurrCard(item.value || item)}
        />
        <Button variant="text" onClick={onAddCard} sx={{alignSelf: 'center'}}>or add new payment method</Button>
        <Typography variant="h5">Your copay is</Typography>
        <Typography variant="h5" fontWeight="bold">${displayCopay}</Typography>
        <Box sx={{ display: 'flex', gap: 1, borderTop: '1px solid #E3E3E3', paddingTop: 1 }}>
          <Button
            variant="contained"
            size="large"
            disabled={!enabledForm()}
            onClick={() => currCard && onPayNow(currCard)}
          >
            Pay Now
          </Button>
          <Button 
            variant="outlined"
            size="large"
            onClick={() => onClose()}
          >
            Cancel
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ModalUseCreditCardOnFile;
